import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@/components/ui/table';

import { Chip, Icon } from '@/components';
import { OfferEntryTable } from '@/features/offers/types';
import { getStatusLabel } from '@/helpers';
import { useTranslation } from 'react-i18next';
import { formatedDate } from '@/features/offers/helpers';
import { Link } from 'react-router-dom';
import { Route } from '@/constants';

export type OpportunityOffersItemProps = {
  readonly items: OfferEntryTable[];
  readonly onItemClick?: (offer: OfferEntryTable) => void;
};

export function OpportunityOffersItem({ items, onItemClick }: OpportunityOffersItemProps) {
  const { t } = useTranslation(['offers']);

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-1/6">{t('Date')}</TableHead>
          <TableHead className="w-2/6">{t('Company')}</TableHead>
          <TableHead className="w-1/6">{t('Status')}</TableHead>
          <TableHead className="w-1/6 text-center">{t('See Details')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((offer) => (
          <Link
            key={offer.id}
            to={Route.SellingOffer.replace(':offerId', offer.id)}
            aria-label={`Open offer from ${offer.company.name ?? ''}`}
            className="contents"
            onClick={() => onItemClick?.(offer)}
          >
            <TableRow className="hover:bg-neutral-25 cursor-pointer">
              <TableCell className="p-1">{formatedDate(offer.createdAt, 'es-ES')}</TableCell>
              <TableCell className="p-1">{offer.company.name}</TableCell>
              <TableCell className="p-1">
                <Chip color={offer.status.color}>{getStatusLabel(offer.status.name)}</Chip>
              </TableCell>
              <TableCell className="flex justify-center p-1">
                <Icon
                  name="eye-open"
                  className="hover:bg-primary-700 text-primary-700 h-8 w-8 rounded-sm p-1 transition duration-200 ease-in-out hover:text-white"
                />
              </TableCell>
            </TableRow>
          </Link>
        ))}
      </TableBody>
    </Table>
  );
}
